import _ from 'lodash';
import { FTProcess } from '@/models/FTProcess';
import { FTProcessRow } from '@/models/FTProcessRow';
import store from '../store';
import { compareStringIgnoreCase } from '@/utils';
import { standardFunctions } from './standardFunctions';

export function orderProgress(productionReports: any[], factoryTicketProcesses: any[]): { averageProgress: number, progressArray: any[] } {
  const convertQuantity = (quantity: number, ftProcessRow: FTProcessRow) => {
    const goodsObject = store.getters.getGoodFromId(ftProcessRow._id);
    if(compareStringIgnoreCase(_.get(goodsObject, 'rawMaterialUnit', ''),'SQM')) {
      return standardFunctions['kgToSQM'](quantity, goodsObject);
    } 
    return quantity;
  }
  const progressArray = _.map(factoryTicketProcesses, (process: FTProcess, index: number) => {
    let netWeight = 0;
    _.forEach(process.outputs, (outputProcessRow: FTProcessRow) => {
      if(process.type === 'Packing') {
        netWeight += standardFunctions['kgToPcs'](outputProcessRow.quantity, outputProcessRow.goodsObject)
      } else {
        netWeight += convertQuantity(outputProcessRow.quantity, outputProcessRow);
      }
    });
    netWeight = netWeight || process.conversionDetails.netWeight;
    const approvedProcessProductionReports = productionReports.filter((productionReport: any) => {
      return productionReport.approval == 'approved' && _.get(productionReport, 'process.outputs.0._id', 0) == _.get(process, 'outputs.0._id')
    });
    const pendingProcessProductionReports = productionReports.filter((productionReport: any) => {
      return productionReport.approval == 'pending' && _.get(productionReport, 'process.outputs.0._id', 0) == _.get(process, 'outputs.0._id')
    });
    let producedQty = 0;
    _.forEach(approvedProcessProductionReports, (productionReport: any) => {
      _.forEach(productionReport.process.outputs, (output: any) => {
        if(process.type === 'Packing') {
          producedQty += standardFunctions['kgToPcs'](_.get(output, 'report.quantity', 0), store.getters.getGoodFromId(output._id))
        } else {
          producedQty = producedQty + convertQuantity(_.get(output, 'report.quantity', 0), output);
        }
      })
    })
    const progress = (producedQty/netWeight) * 100;
    return { index, type: process.type, producedQty, approvedProcessProductionReports, pendingProcessProductionReports, netWeight, progress };
  })
  const averageProgress: number = _.round(
    _.reduce(progressArray, 
      (totalProgress: number, currentProgess: any) => totalProgress + _.get(currentProgess, 'progress', 0),
      0) / progressArray.length);
  return { averageProgress, progressArray };
}